namespace TabAurous.HR {
    export interface SalaryPackageRow {
        SalaryPackageId?: number;
        Code?: string;
        Narration?: string;
        TotalAmount?: number;
        IsDisabled?: boolean;
        PackageDetails?: SalaryPackageDetailsRow[];
    }

    export namespace SalaryPackageRow {
        export const idProperty = 'SalaryPackageId';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'HR.SalaryPackage';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            SalaryPackageId = "SalaryPackageId",
            Code = "Code",
            Narration = "Narration",
            TotalAmount = "TotalAmount",
            IsDisabled = "IsDisabled",
            PackageDetails = "PackageDetails"
        }
    }
}
